module.exports = __webpack_public_path__ + "resource/img/image039.75cffdd4.png";